import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=5fcab099"
import script from "./VideoSection.vue?vue&type=script&lang=js"
export * from "./VideoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports